import update from "immutability-helper";

const app = (
  state = {
    loading: true,
    activeMenuItem: null,
  },
  action,
) => {
  switch (action.type) {
    case "APP_LOADING":
      state = update(state, {
        loading: {
          $set: action.payload,
        },
      });
      break;

    default:
      break;
  }
  return state;
};

export default app;



// WEBPACK FOOTER //
// ./src/services/appReducer.js